const dsCredentials = {
  url: 'wss://013.deepstreamhub.com?apiKey=c7b20154-5e81-48c4-a656-a887d82adc9c',
  authParams: {
    type: 'email',
    email: 'pierce@primm.cc',
    password: 'cletus123'
  }
}

export default dsCredentials


// WEBPACK FOOTER //
// ./src/dsCredentials.js